export const CAT_RUNNING_STAGE_KEY = 'forest';
export const CAT_RUNNING_CHARACTER_KEY = 'a';

export const CAT_RUNNING_CANVAS_WIDTH = 390;
export const CAT_RUNNING_CANVAS_HEIGHT = 800;
export const CAT_RUNNING_GROUND_Y = 495;
export const CAT_RUNNING_WARMUP_DISTANCE = 50;
export const CAT_RUNNING_REVIVE_WARMUP_DISTANCE = 30;
export const CAT_RUNNING_REVIVE_GRACE_MS = 2500;
export const CAT_RUNNING_SHIELD_DURATION_MS = 5000;
export const CAT_RUNNING_MAGNET_DURATION_MS = 5000;
export const CAT_RUNNING_MAGNET_RADIUS = 120;
export const CAT_RUNNING_MAGNET_PULL_SPEED = 300;

export const CAT_RUNNING_PLAYER_X = 28;
export const CAT_RUNNING_PLAYER_WIDTH = 63;
export const CAT_RUNNING_PLAYER_HEIGHT = 38;
export const CAT_RUNNING_PLAYER_DEATH_WIDTH = 60;
export const CAT_RUNNING_PLAYER_DEATH_HEIGHT = 25;
export const CAT_RUNNING_RUN_FRAME_MS = 95;
export const CAT_RUNNING_GRAVITY = 1800;
export const CAT_RUNNING_JUMP_VELOCITY = -555;

export const CAT_RUNNING_INITIAL_SPEED = 280;
export const CAT_RUNNING_MAX_SPEED = 560;
export const CAT_RUNNING_SPEED_GAIN_PER_SEC = 14;

export const CAT_RUNNING_BACKGROUND_SCROLL_RATIO = 0.5;
export const CAT_RUNNING_TEST_CROW_MODE = false;
export const CAT_RUNNING_TEST_CROW_SPAWN_MIN_MS = 500;
export const CAT_RUNNING_TEST_CROW_SPAWN_MAX_MS = 850;
export const CAT_RUNNING_OBSTACLE_SPAWN_X = CAT_RUNNING_CANVAS_WIDTH + 48;
export const CAT_RUNNING_OBSTACLE_DESPAWN_MARGIN = 96;
export const CAT_RUNNING_OBSTACLE_MIN_SPAWN_MS = 1200;
export const CAT_RUNNING_OBSTACLE_MAX_SPAWN_MS = 1900;
export const CAT_RUNNING_PHASE_2_SPEED = 351;
export const CAT_RUNNING_PHASE_3_SPEED = 441;
export const CAT_RUNNING_GROUND_OBSTACLE_SPECS = [
  { key: 'hurdle-a', width: 44, height: 53 },
  { key: 'hurdle-b', width: 62, height: 24 },
  { key: 'hurdle-c', width: 64, height: 55 },
];
export const CAT_RUNNING_CROW_FRAME_MS = 140;
export const CAT_RUNNING_CROW_WIDTH = 48;
export const CAT_RUNNING_CROW_HEIGHT = 30;
export const CAT_RUNNING_CROW_LOW_Y = CAT_RUNNING_GROUND_Y - 40;
export const CAT_RUNNING_CROW_HIGH_Y = CAT_RUNNING_GROUND_Y - 80;

export const CAT_RUNNING_CHURU_SPAWN_X = CAT_RUNNING_CANVAS_WIDTH + 48;
export const CAT_RUNNING_CHURU_DESPAWN_MARGIN = 64;
export const CAT_RUNNING_CHURU_MIN_SPAWN_MS = 450;
export const CAT_RUNNING_CHURU_MAX_SPAWN_MS = 950;
export const CAT_RUNNING_CHURU_WIDTH = 23;
export const CAT_RUNNING_CHURU_HEIGHT = 35;
export const CAT_RUNNING_CHURU_BUNDLE_GAP_X = 18;
export const CAT_RUNNING_CHURU_LEVEL_Y = [CAT_RUNNING_GROUND_Y - 15, CAT_RUNNING_GROUND_Y - 75];
export const CAT_RUNNING_CHURU_BUNDLE_OFFSET_MIN_Y = 18;
export const CAT_RUNNING_CHURU_BUNDLE_OFFSET_MAX_Y = 22;

export const CAT_RUNNING_SKY_TOP_COLOR = '#A9E7FF';
export const CAT_RUNNING_SKY_BOTTOM_COLOR = '#EBFFF5';

export const CAT_RUNNING_HITBOX_INSETS = {
  player: { top: 4, right: 6, bottom: 4, left: 6 },
  churu: { top: 4, right: 4, bottom: 4, left: 4 },
  obstacleGround: { top: 6, right: 6, bottom: 6, left: 6 },
  obstacleCrow: { top: 8, right: 8, bottom: 5, left: 8 },
};
